import { Field, Form } from 'react-final-form'
import { useFlixApiContext } from '@mwxltd/flix-api-client'
import { Button, ButtonRow } from '@flix/common/elements/controls'
import { required, requiredEmail, requiredFullName } from '@flix/common/elements/forms/validators'
import { TextInput } from '@flix/common/elements/input'
import formMsgs from '../../../components/forms/messages'
import { useSnackbar } from '../../../containers/app/Snackbar/SnackbarContext'

export const FilmPartnersForm = () => {
  const { flixApi } = useFlixApiContext()
  const { snackbarMsg } = useSnackbar()
  return (
    <Form
      onSubmit={(values) =>
        flixApi('post', 'film-partners', values)
          .then(() => snackbarMsg('Thank you for signing up', 'We will contact you soon!', {}))
          .catch(() =>
            snackbarMsg('Sorry, something went wrong. Please try again.', {
              bsStyle: 'danger',
            }),
          )
      }
    >
      {({ handleSubmit, submitting }) => (
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <Field
            name="name"
            component={TextInput}
            label={formMsgs.name}
            validate={requiredFullName}
          />
          <Field
            name="email"
            type="email"
            component={TextInput}
            label={formMsgs.email}
            validate={requiredEmail}
          />
          <Field name="tel" component={TextInput} validate={required} label={formMsgs.phoneNo} />
          <Field
            name="company"
            component={TextInput}
            validate={required}
            label={formMsgs.company}
          />
          <Field name="website" component={TextInput} label={formMsgs.website} />
          <Field
            name="country"
            component={TextInput}
            validate={required}
            label={formMsgs.country}
            onSubmitEditing={handleSubmit}
            returnKeyType="go"
          />

          <ButtonRow>
            <Button
              onPress={handleSubmit}
              disabled={submitting}
              intlMsg={submitting ? formMsgs.submitting : formMsgs.submit}
              mb="none"
            />
          </ButtonRow>

          <button type="submit" style={{ display: 'none' }} />
        </form>
      )}
    </Form>
  )
}
